import Engines from 'pages/ga/engines/Index';
import EnginesAdd from 'pages/ga/engines/Add';
import EnginesView from 'pages/ga/engines/View';

const EnginesRoutes = [
    { index: true, element: <Engines /> },
    { path: 'add', element: <EnginesAdd /> },
    { path: 'view/:id', element: <EnginesView /> },
];

export default EnginesRoutes;
